"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountRegion = exports.CallbackRegion = exports.UserRegion = exports.Region = void 0;
var Region;
(function (Region) {
    Region["Brazil"] = "BR";
    Region["EuropeNordic"] = "EUNE";
    Region["EuropeWest"] = "EUW";
    Region["LatinAmericaNorth"] = "LAN";
    Region["LatinAmericaSouth"] = "LAS";
    Region["NorthAmerica"] = "NA";
    Region["Oceania"] = "OCE";
    Region["Russia"] = "RU";
    Region["Turkey"] = "TR";
    Region["Japan"] = "JP";
    Region["RepublicOfKorea"] = "KR";
    Region["PublicBetaEnvironment"] = "PBE";
})(Region = exports.Region || (exports.Region = {}));
var UserRegion;
(function (UserRegion) {
    UserRegion["BR1"] = "BR1";
    UserRegion["EUN1"] = "EUN1";
    UserRegion["EUW1"] = "EUW1";
    UserRegion["LA1"] = "LA1";
    UserRegion["LA2"] = "LA2";
    UserRegion["NA1"] = "NA1";
    UserRegion["OC1"] = "OC1";
    UserRegion["RU"] = "RU";
    UserRegion["TR1"] = "TR1";
    UserRegion["JP1"] = "JP1";
    UserRegion["KR"] = "KR";
    UserRegion["PBE1"] = "PBE1";
})(UserRegion = exports.UserRegion || (exports.UserRegion = {}));
var CallbackRegion;
(function (CallbackRegion) {
    CallbackRegion["BR1"] = "br1";
    CallbackRegion["EUN1"] = "eun1";
    CallbackRegion["EUW1"] = "euw1";
    CallbackRegion["LA1"] = "la1";
    CallbackRegion["LA2"] = "la2";
    CallbackRegion["NA1"] = "na1";
    CallbackRegion["OC1"] = "oc1";
    CallbackRegion["RU"] = "ru";
    CallbackRegion["TR1"] = "tr1";
    CallbackRegion["JP1"] = "jp1";
    CallbackRegion["KR"] = "kr";
    CallbackRegion["PBE1"] = "pbe1";
})(CallbackRegion = exports.CallbackRegion || (exports.CallbackRegion = {}));
var AccountRegion;
(function (AccountRegion) {
    AccountRegion["Americas"] = "americas";
    AccountRegion["Asia"] = "asia";
    AccountRegion["Europe"] = "europe";
    AccountRegion["Esports"] = "esports";
})(AccountRegion = exports.AccountRegion || (exports.AccountRegion = {}));
//# sourceMappingURL=region.js.map